


import Vue from 'vue';

export default Vue.extend({
	name: 'Tooltip',
	props: ['content'],
	mounted: function () {
		/**
		 * @todo Are there general or performance concerns around re-running this for every tooltip?
		 */
		window.gform_initialize_tooltips();
	},
	computed: {
		isLegacy: function () {
			return document.body.classList.contains('gf-legacy-ui');
		},
	}
});
